module.exports = __webpack_public_path__ + "static/A01-a7b3e5aa70d0ca3cdde5fb262ea3a336.jpg";